import Address from './Address';

const Addresses = ({ addresses, onDelete, onEdit, onSetMain }) => {

    return (<>
        {addresses && addresses.map((address, index) => {
            return <Address key={index} address={address} index={index} onDelete={onDelete} onEdit={onEdit} onSetMain={onSetMain} />
        })}
    </>
    )
}

export default Addresses